import { ref, computed, watchEffect } from "vue";

const STORAGE_KEY = "v2-theme";

// Module-level singleton — shared across all components
const theme = ref(localStorage.getItem(STORAGE_KEY) ?? "system"); // 'light' | 'dark' | 'system'

const media = window.matchMedia("(prefers-color-scheme: dark)");
const systemPrefersDark = ref(media.matches);
media.addEventListener("change", (e) => { systemPrefersDark.value = e.matches; });

const isDark = computed(() => theme.value === "system" ? systemPrefersDark.value : theme.value === "dark");

// Apply immediately so there's no flash on load
document.documentElement.classList.toggle("dark", isDark.value);

watchEffect(() => {
  document.documentElement.classList.toggle("dark", isDark.value);
  localStorage.setItem(STORAGE_KEY, theme.value);
});

export function useTheme() {
  function toggleTheme() {
    theme.value = isDark.value ? "light" : "dark";
  }

  function setTheme(value) {
    if (value === "light" || value === "dark" || value === "system") theme.value = value;
  }

  return { theme, isDark, toggleTheme, setTheme };
}
